



























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import CopyCurrentUrlButton from "@/components/shared/CopyCurrentUrlButton.vue";
import QrButton from "@/components/shared/QrButton.vue";
import { DialogProgrammatic as Dialog } from "buefy";
import { PUBLIC_VIEWER_POSTER_NAME_SUFFIX } from "../../services/constants";
import { db, firestore } from "@/scripts/firebase";
import { collectionName } from "../../services/collection-name";
import { ToastProgrammatic as Toast } from "buefy";
import { TOAST_DURATION_MILLISECONDS } from "@/services/constants";
import Guest from "../JinroRoom/ManageJinroPlayers/Guest.vue";
import { GuestPlayerUrlSendingQueueParams } from "../../services/paramstypes";

@Component({
  components: {
    CopyCurrentUrlButton,
    QrButton,
  },
})
export default class ShowPlayStatus extends Vue {
  sendEmail() {
    Dialog.prompt({
      message: this.dialogueMessage,
      inputAttrs: {
        type: "email",
        placeholder: "あなたのメールアドレス",
        maxlength: 30,
      },
      cancelText: "キャンセル",
      confirmText: "送信する",
      onConfirm: async (value) => await this.createGuestUrlSendQueue(value),
    });
  }

  get dialogueMessage() {
    return '専用URLを下記のアドレスに送信します。<br/> <span class="note">*専用URL送信以外の用途には 入力されたアドレスは利用されません</span>';
  }

  get jinroRoomTitle(): string {
    if (!this.$store.state.jinroRoom) {
      return "";
    }
    return this.$store.state.jinroRoom.title;
  }

  get jinroRoomOwner(): string {
    if (!this.$store.state.jinroRoom) {
      return "";
    }
    return this.$store.state.jinroRoom.owner;
  }

  get playerName(): string {
    if (!this.$store.state.jinroPlayer) {
      return "";
    }
    return this.$store.state.jinroPlayer.playerName;
  }

  async createGuestUrlSendQueue(email: string) {
    const params: GuestPlayerUrlSendingQueueParams = {
      playerId: this.$route.params.jinroPlayerId,
      email: email,
      jinroRoomTitle: this.jinroRoomTitle,
      playerName: this.playerName,
      jinroRoomOwner: this.jinroRoomOwner,
      isProcessed: false,
      playerUrl: this.currentUrl,
      timeCreated: firestore.FieldValue.serverTimestamp(),
    };
    await db.collection(collectionName.guestplayerurlsendingqueue).add(params);
    this.onSending(email);

    return;
  }

  get currentUrl(): string {
    return window.location.href;
  }

  onSending(e: string) {
    Toast.open({
      duration: TOAST_DURATION_MILLISECONDS,
      queue: false,
      message: ` ${e}にメールを送信します。メールボックスをご確認ください。`,
    });
  }
}
